import { useEffect, useState } from "react";
import { useAuthCheck } from "../util/utils";
import { useCookies, withCookies } from "react-cookie";

const PrivacyPreferencesComponent = ({ api, onClose }) => {

    useAuthCheck()

    const [cookies, setCookie] = useCookies([])
    const [loading, setLoading] = useState(true)

    const [userInfo, setUserInfo] = useState({
        privateProfile: false,
        searchable: false,
        newFollowerEmails: false,
        monthlyBirthdayEmails: false,
        sendFollowRecs: false
    });
    const [originalInfo, setOriginalInfo] = useState({})

    const togglePreference = (key, value) => {
        setUserInfo((prev) => ({ ...prev, [key]: !prev[key] }));
    }

    const handleSave = async () => {
        let needsPrivacyUpdate = false
        let needsEmailUpdate = false
        const update = {}
        if (userInfo.privateProfile != originalInfo.privateProfile) {
            needsPrivacyUpdate = true
            update.isPrivate = userInfo.privateProfile
        }
        if (userInfo.searchable != originalInfo.searchable) {
            needsPrivacyUpdate = true
            update.searchable = userInfo.searchable
        }

        const emailUpdate = {}
        if (userInfo.newFollowerEmails != originalInfo.newFollowerEmails) {
            needsEmailUpdate = true
            emailUpdate.sendFollowerEmails = userInfo.newFollowerEmails
        }
        if (userInfo.monthlyBirthdayEmails != originalInfo.monthlyBirthdayEmails) {
            needsEmailUpdate = true
            emailUpdate.sendMonthlyEmails = userInfo.monthlyBirthdayEmails
        }
        if (userInfo.sendFollowRecs != originalInfo.sendFollowRecs) {
            needsEmailUpdate = true
            emailUpdate.sendFollowRecs = userInfo.sendFollowRecs
        }

        let success = false
        let error = false

        if (needsPrivacyUpdate) {
            try {
                const res = await api().updateMe(cookies.token, update)

                if (res.status === 200) {
                    setUserInfo((prev) => ({
                        ...prev,
                        privateProfile: res.data.isPrivate,
                    }));
                    success = true
                }

            } catch (e) {
                error = true
            }
        }

        if (needsEmailUpdate) {
            try {
                const res = await api().updateMarketingPrefs(cookies.token, emailUpdate)

                if (res.status === 200) {
                    setUserInfo((prev) => ({
                        ...prev,
                        newFollowerEmails: res.data.sendFollowerEmails,
                        monthlyBirthdayEmails: res.data.sendMonthlyEmails,
                        sendFollowRecs: res.data.sendFollowRecs
                    }))
                    success = true
                }
            } catch (e) {
                error = true
            }
        }

        if (error) {
            onClose({ message: `Something went wrong...`, type: "error" })
        } else if (success) {
            onClose({ message: `Your profile has been updated` })
        }
    }

    const fetchMe = async () => {
        try {
            let resp = await api().getMe(cookies.token)
            if (resp.status === 200) {
                setUserInfo((prev) => ({
                    ...prev,
                    privateProfile: resp.data.isPrivate,
                    searchable: resp.data.searchable
                }));
                setOriginalInfo((prev) => ({
                    ...prev,
                    privateProfile: resp.data.isPrivate,
                    searchable: resp.data.searchable
                }));

            }
        } catch (e) { }
        setLoading(false)
    }

    const fetchMarketing = async () => {
        try {
            let resp = await api().getMarketingPrefs(cookies.token)
            if (resp.status === 200) {
                setUserInfo((prev) => ({
                    ...prev,
                    newFollowerEmails: resp.data.sendFollowerEmails,
                    monthlyBirthdayEmails: resp.data.sendMonthlyEmails,
                    sendFollowRecs: resp.data.sendFollowRecs
                }))
                setOriginalInfo((prev) => ({
                    ...prev,
                    newFollowerEmails: resp.data.sendFollowerEmails,
                    monthlyBirthdayEmails: resp.data.sendMonthlyEmails,
                    sendFollowRecs: resp.data.sendFollowRecs
                }))
            }
        } catch (e) { }
    }

    useEffect(() => {
        if (cookies.token) fetchMe()
    }, [cookies.token])

    useEffect(() => {
        if (cookies.token) fetchMarketing()
    }, [cookies.token])

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            {/* Popup Container */}
            <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md relative">
                {/* Header */}
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h2 className="text-xl font-semibold">Privacy & Preferences</h2>
                    <button onClick={onClose} className="p-2 text-gray-500 hover:text-gray-700">
                        ✕
                    </button>
                </div>

                {/* Loading State */}
                {loading ? (
                    <div className="text-center py-6">
                        <div className="animate-spin h-6 w-6 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
                        <p className="text-gray-600 mt-2 text-sm">Loading preferences...</p>
                    </div>
                ) : (
                    <div className="space-y-4">
                        {/* First Item */}
                        <div className="text-gray-500 text-xs uppercase font-semibold">Privacy</div>
                        <label className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg cursor-pointer">
                            <input
                                type="checkbox"
                                checked={userInfo.privateProfile}
                                onChange={() => togglePreference("privateProfile")}
                                className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring focus:ring-blue-300"
                            />
                            <div className="flex-1">
                                <p className="text-sm font-medium">Private profile</p>
                                <p className="text-xs text-gray-600">Other people have to request to follow you. You have to approve people to follow you</p>
                            </div>
                        </label>

                        {/* <label className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={userInfo.searchable}
                                    onChange={() => togglePreference("searchable")}
                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring focus:ring-blue-300"
                                />
                                <div className="flex-1">
                                    <p className="text-sm font-medium">Show me in search</p>
                                    <p className="text-xs text-gray-600">You show up when other people search for you. If someone follows you, they will always be able to find you in search</p>
                                </div>
                            </label> */}

                        {/* Section Header */}
                        <div className="text-gray-500 text-xs uppercase font-semibold pt-2 border-t">Email</div>

                        <label className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg cursor-pointer">
                            <input
                                type="checkbox"
                                checked={userInfo.newFollowerEmails}
                                onChange={() => togglePreference("newFollowerEmails")}
                                className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring focus:ring-blue-300"
                            />
                            <div className="flex-1">
                                <p className="text-sm font-medium">New follower emails</p>
                                <p className="text-xs text-gray-600">We'll send you an email when someone follows you</p>
                            </div>
                        </label>

                        <label className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg cursor-pointer">
                            <input
                                type="checkbox"
                                checked={userInfo.monthlyBirthdayEmails}
                                onChange={() => togglePreference("monthlyBirthdayEmails")}
                                className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring focus:ring-blue-300"
                            />
                            <div className="flex-1">
                                <p className="text-sm font-medium">Monthly emails</p>
                                <p className="text-xs text-gray-600">We'll send you an email at the start of each month with all your upcoming birthdays that month</p>
                            </div>
                        </label>


                        <label className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg cursor-pointer">
                            <input
                                type="checkbox"
                                checked={userInfo.sendFollowRecs}
                                onChange={() => togglePreference("sendFollowRecs")}
                                className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring focus:ring-blue-300"
                            />
                            <div className="flex-1">
                                <p className="text-sm font-medium">Follower recommendations</p>
                                <p className="text-xs text-gray-600">Occasionally, we'll send you emails about people we think you may know and might want to follow</p>
                            </div>
                        </label>
                    </div>
                )}

                {/* Save Button (Disabled during loading) */}
                <button
                    onClick={handleSave}
                    disabled={loading}
                    className={`mt-4 w-full py-2 rounded-lg ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"}`}
                >
                    {loading ? "Loading..." : "Save Preferences"}
                </button>
            </div>
        </div>
    );
};

const PrivacyPreferences = withCookies(({ api, onClose }) => (
    <PrivacyPreferencesComponent onClose={onClose} api={api} />
))

export default PrivacyPreferences;
